import React from 'react';
import CounterCard from '../../../../../../components/Molecules/Card/CounterCard/CounterCard';
import SelectCard from '../../../../../../components/Molecules/Card/SelectCard/SelectCard';
import { isItSubstituteGroup, verifyStatus } from '../../../../../../helpers/customizedItem/customizedItem.helper';
import * as Constants from '../../../../../../constants';
import { IItemModifierRequiredGroups } from '../../../../../../models/try2Combo';
import { selectedIngredient } from '../../../../../../helpers/helperMethods';
import { IRequiredModifiersGroupsModifiers } from '../../../../../../models/item.model';

const ItemModifierRequiredGroups: React.FC<IItemModifierRequiredGroups> = (props) => {
  const { ingredients, selectedIngredients, handleClick, isLimitExceed, customizedItemSize, remainingBase , showAdditionalPrice, itemBase,itemModifierItemModalWidth, showRedBorderAnimation, isCreateYourOwnItem} = props;
  
  const decideCard = (modifier:IRequiredModifiersGroupsModifiers) => {
    return selectedIngredientsOfAGroup(ingredients?.id)?.length > 0 && !isItSubstituteGroup(ingredients) && modifier?.max > 1
  }

  const selectedIngredientsOfAGroup = (groupId:number) => {
    return selectedIngredients?.filter(ingredient => ingredient?.modifier_group_id === groupId)
  }

  return (
    <>
      {ingredients?.required_modifiers_groups_modifiers?.map(
        (modifier, index: number) => {
          const selectedSide = selectedIngredient(modifier, selectedIngredients);
          return (
            <React.Fragment key={index}>
              <div className={`${customizedItemSize ? 'item__modifier_item dressing_items' : 'py-md-3 col-md-3 col-4'} ${itemModifierItemModalWidth}`}>
                {decideCard(modifier) ? (
                  <CounterCard 
                    id={modifier?.id}
                    brink_id={modifier?.brink_modifier_id}
                    image={`${Constants.REACT_APP_CLOUD_FRONT}${modifier?.image}`}
                    title={modifier.name}
                    price={modifier.price}
                    calories={modifier.calories}
                    max={modifier.max}
                    groupMin={ingredients.min}
                    is_active={verifyStatus(
                      modifier,
                      Constants.MODIFIER_LOCATION
                    )}
                    priceAlternateLabel={selectedSide ? ' ' : ' '}
                    handleClick={(data) => {
                      handleClick(data, modifier?.in_item);
                    } }
                    isCreateYourOwnItem={isCreateYourOwnItem}
                    count={selectedSide?.quantity || 0}
                    from={Constants.TRY_2_COMBO}
                    additionalPrice={selectedSide?.additionalPrice}
                    extendableLimit={isLimitExceed(
                      ingredients.extendable_limit
                    )}
                    extendableLimitValue={ingredients.extendable_limit}
                    itemBase={itemBase}
                    remainingBase={remainingBase}
                    showAdditionalPrice={showAdditionalPrice}
                    showRedBorderAnimation={showRedBorderAnimation} 
                                    />
                ) : (
                  <SelectCard
                    id={modifier?.id}
                    brink_id={modifier?.brink_modifier_id}
                    image={`${Constants.REACT_APP_CLOUD_FRONT}${modifier?.image}`}
                    title={modifier.name}
                    price={modifier.price}
                    calories={modifier.calories}
                    groupMin={ingredients.min}
                    is_active={verifyStatus(
                      modifier,
                      Constants.MODIFIER_LOCATION
                    )}
                    handleClick={(data) => {
                      handleClick(data, modifier?.in_item);
                    }}
                    priceAlternateLabel={selectedSide ? ' ' : ' '}
                    selected={Boolean(selectedSide)}
                    modifierAdditionalPrice={selectedSide?.additionalPrice}
                    extendableLimit={isLimitExceed(
                      ingredients.extendable_limit
                    )}
                    isCreateYourOwnItem={isCreateYourOwnItem}
                    extendableLimitValue={ingredients.extendable_limit}
                    showRedBorderAnimation={showRedBorderAnimation}
                  />
                )}
              </div>
            </React.Fragment>
          );
        }
      )}
    </>
  );
};

export default ItemModifierRequiredGroups;
